var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-container",class:{
    'buttons-wrapper': _vm.buttonsWrap,
    'header-wrapper': _vm.headerWrap,
    container: _vm.container
  },style:({ ..._vm.cssVars, ..._vm.styles }),attrs:{"data-section":_vm.sectionId}},_vm._l((_vm.fields),function(field){return _c('component-renderer',{key:field.id,attrs:{"sectionId":_vm.sectionId,"field":field,"isFromBuilder":_vm.isFromBuilder},on:{"component-updated":_vm.updated}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }